import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Container from 'components/Container';
import { CaretLeftIcon } from '@phosphor-icons/react';
import { useQuery } from '@tanstack/react-query';
import { getDocuments } from 'api/documents';
import Button from 'components/Button';
import { getFolder } from 'api/folders';
import DocumentPopupUpload from 'components/Documents/DocumentPopupUpload';
import DocumentListItem from 'components/Documents/DocumentListItem';
import Page from 'components/Layout/Page';

export default function List() {

    const [uploadPopup, setUploadPopup] = useState(false);

    const { folderId } = useParams();

    const { data: folder, isLoading: isFolderLoading } = useQuery({
        queryKey: ['folders', folderId],
        queryFn: async () => await getFolder({ id: folderId }),
        enabled: Boolean(folderId),
    });

    const { data: documents, isLoading: isDocumentsLoading } = useQuery({
        queryKey: ['documents', folderId],
        queryFn: async () => await getDocuments({
            params: {
                folder: folderId,
                sort: {
                    createdAt: -1
                }
            }
        }),
    });

    const isLoading = isFolderLoading || isDocumentsLoading;

    const openUploadHandler = () => {
        setUploadPopup(true);
    }

    return (
        <>
            <Page isLoading={isLoading}>
                <Container>
                    <div className='flex gap-3 items-center pb-8 pt-20 md:pt-14'>
                        <div className='flex-1 flex items-center gap-3'>
                            <Link to={`/settings/documents`} className=''>
                                <CaretLeftIcon size={26} className='hover:text-muted' />
                            </Link>
                            <p className='text-3xl'>{folder?.name}</p>
                        </div>
                        <Button onClick={openUploadHandler}>Carica nuovo file</Button>
                        <Button component={Link} to={`/settings/documents/${folderId}/edit`}>Info</Button>
                    </div>

                    <div className=''>
                        <div className='border border-light rounded-sm mt-6'>
                            {documents?.map(document => <DocumentListItem key={document._id} document={document} />)}
                        </div>
                    </div>
                </Container>
            </Page>

            <DocumentPopupUpload
                visible={uploadPopup}
                setVisible={setUploadPopup}
                folderId={folderId}
            />
        </>
    )
}
